var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 594,
    viewBox: "0 0 328 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    width: 233,
    height: 32,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 38,
    width: 209,
    height: 32,
    rx: 4,
    fill: "#F6F8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 328,
    height: 392,
    rx: 12,
    fill: "#F6F8FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 104,
    y: 252,
    width: 120,
    height: 48,
    rx: 8,
    fill: "#E7ECFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 69,
    y: 330,
    width: 190,
    height: 21,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 94,
    y: 363,
    width: 140,
    height: 19,
    rx: 4,
    fill: "#E7ECFE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 526,
    width: 164,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192,
    y: 526,
    width: 116,
    height: 48,
    rx: 10,
    fill: "#E7ECFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderMobile);
export default __webpack_public_path__ + "static/media/loader-mobile.964fe0b601004a3ed4896b1d1de7dbfd.svg";
export { ForwardRef as ReactComponent };